const Populacja = 38000000;
export const PRZELICZNIKI = {
  Populacja,
  spalanieGazuDoWyprodukowania1TWHEnergii: 0.2016,
  emisyjnośćElektrowniGazowej: 402,
  sprawnośćElektrolizerów: 0.6,
  energia1MlnTonWodoru: 33.3,
};
